<template>
<div class="chapter">
<div class="inner_page">
<div id="fm3">
<p class="headimg">ALSO BY KATE GRENVILLE</p>
<p class="also"><span class="small">NOVELS</span></p>
<p class="also"><em class="italic">Lilian’s Story</em></p>
<p class="also"><em class="italic">Dark Places</em></p>
<p class="also"><em class="italic">Dreamhouse</em></p>
<p class="also"><em class="italic">Joan Makes History</em></p>
<p class="also"><em class="italic">The Idea of Perfection</em></p>
<p class="also"><em class="italic">The Secret River</em></p>
<p class="also"><em class="italic">The Lieutenant</em></p>
<p class="also1"><span class="small">SHORT STORIES</span></p>
<p class="also" style="margin-top: .2em;"><em class="italic">Bearded Ladies</em></p>
<p class="also1"><span class="small">NON-FICTION</span></p>
<p class="also"><em class="italic">The Writing Book</em></p>
<p class="also"><em class="italic">Making Stories </em>(with Sue Woolfe)</p>
<p class="also"><em class="italic">Writing from Start to Finish</em></p>
<p class="also"><em class="italic">Searching for the Secret River</em></p>
<p class="also1">Notes for readers available at <a href="http://kategrenville.com" target="_blank">kategrenville.com</a></p>
<p class="also">Teachers’ notes and reading group notes for <em class="italic">Sarah Thornhill</em> available at <a href="http://textpublishing.com.au/resources" target="_blank">textpublishing.com.au/resources</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also_by.vue?0a00de6d